<template>
  <div class="flex flex-col">
    <div class="flex flex-col lg:flex-row gap-4 lg:gap-6 items-start">
      <status-side-nav :options="storeNavOptions" />

      <router-view class="flex-1 min-w-0 w-full min-h-screen" />
    </div>
  </div>
</template>

<script>
import StatusSideNav from "@/components/ui/StatusSideNav";
import { mapState } from "vuex";
export default {
  name: "Store",

  components: {
    StatusSideNav,
  },

  computed: {
    ...mapState({
      storeSelectedTab: "storeSelectedTab",
    }),

    storeNavOptions() {
      const options = [
        {
          label: "Productos",
          icon: "📦",
          to: { name: "productsIndex" },
          active: this.storeSelectedTab === "products",
        },
        {
          label: "Categorías",
          icon: "🗂️",
          to: { name: "productCategoriesIndex" },
          active: this.storeSelectedTab === "productCategories",
        },
      ];

      if (this.hasPermission("view_coupons")) {
        options.push({
          label: "Cupones",
          icon: "🎟️",
          to: { name: "couponsIndex" },
          active: this.storeSelectedTab === "coupons",
        });
      }

      if (this.hasPermission("view_tags")) {
        options.push({
          label: "Etiquetas",
          icon: "🏷️",
          to: { name: "tagsIndex" },
          active: this.storeSelectedTab === "tags",
        });
      }

      if (this.hasPermission("view_shop_orders")) {
        options.push({
          label: "Pedidos en línea",
          icon: "🛒",
          to: { name: "shopOrdersIndex" },
          active: this.storeSelectedTab === "shopOrders",
        });
      }

      if (this.hasPermission("view_shipping_tiers")) {
        options.push({
          label: "Envíos",
          icon: "🚚",
          to: { name: "shippingTiersIndex" },
          active: this.storeSelectedTab === "shippingTiers",
        });
      }

      return options;
    },
  },

  created() {
    this.$store.commit("setSelectedTab", "store");
  },
};
</script>
